import React from 'react';

class FullscreenView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    return (
      <div className="fullscreenView">
        <div className="close" onClick={this.props.onClose}></div>
        <video
          className="videoSquare"
          controls
          autoPlay
          src={this.props.video}
        />
      </div>
    )
  }
}

export default FullscreenView;



// WEBPACK FOOTER //
// src/FullscreenView.js